import Layout from "@/layouts/layout";
import PageHeading from "@/components/layout/PageHeading";
import Panel from "@/components/ui/Panel";
import GuideBody from "@/components/guides/GuideBody";
import { ButtonLink } from "@/components/ui/Button";
import { Link } from "@inertiajs/react";
import { AUDIENCE_LABELS, type Guide } from "@/interfaces/guide";
import LockedNotice from "@/components/guides/LockedNotice";

export default function GuideShow({
  guide,
  others,
  locked_for_others,
}: {
  guide: Guide;
  others: Guide[];
  locked_for_others: boolean;
}) {
  return (
    <Layout>
      <div className="flex flex-col gap-8">
        <LockedNotice locked={locked_for_others} />

        <PageHeading
          eyebrow={AUDIENCE_LABELS[guide.audience]}
          title={guide.title}
          subtitle={guide.summary}
          actions={
            <ButtonLink href="/guides" variant="secondary">
              All guides
            </ButtonLink>
          }
        />

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <Panel title={`${guide.slug}.md`} className="lg:col-span-2">
            <GuideBody html={guide.body_html ?? ""} />
          </Panel>

          {others.length > 0 && (
            <Panel title="also-read.txt" tone="alt" className="self-start">
              <div className="flex flex-col gap-2.5">
                {others.map((other) => (
                  <Link
                    key={other.id}
                    href={`/guides/${other.slug}`}
                    className="text-body text-ink hover:text-link font-bold"
                  >
                    {other.title}
                  </Link>
                ))}
              </div>
            </Panel>
          )}
        </div>
      </div>
    </Layout>
  );
}
